import { FetchBreakSettingsDocument, FetchBreakSettingsQuery } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const AUTOMATIC_BREAK_SOURCE = {
  RULES: 'rules',
  PLANNED_HOURS: 'planned_hours',
} as const

export type BreakSettingsType =
  FetchBreakSettingsQuery['attendance']['breakSettingsConnection']['nodes'][number]

export const useFetchBreakSettings = (attendanceEmployeesSettingIds: number[]) => {
  const { loading, data, refetch } = useQuery(FetchBreakSettingsDocument, {
    variables: { attendanceEmployeesSettingIds },
    skip: !attendanceEmployeesSettingIds.length,
  })

  const breakSettings = data?.attendance.breakSettingsConnection.nodes || []

  return {
    loading,
    breakSettings,
    refetch,
  }
}
